import React, { useEffect, useState } from "react";
import CheckBox from "canvas-core-react/lib/Checkbox";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Modal from "../../../utils/customModal";
import useApi from "../../../hooks/useApi";
import {
  errorContainer,
  loadingHtml,
  sucessInfoModal,
} from "../../../utils/functions";
import { getUserByCode } from "../../../../Redux/reducer/users";
import {
  getUserByCod,
  clearUserByCode,
} from "../../../../Redux/actions/userActions";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";

const defaultModal = { show: false, content: null };

const ChangesUserDetail = ({ goBack, ...props }) => {
  const [modal, setModal] = useState(defaultModal);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { putApiCAll } = useApi();

  const { user, double, notifications, itemsChanged, userId } = useSelector(
    (state) => {
      const user = getUserByCode(state);

      const dataRef = user?.recordsTmp?.data;
      const double = !!dataRef || !!user?.recordsTmpUserNotificationEmail?.data;

      const checkModule = (item) => {
        const permission = JSON.parse(user.recordsTmp.data?.permissions);
        return permission.some((perm) => perm.permId == item.id);
      };

      const getUpdatedModules = () => {
        return !user.recordsTmp.data?.permissions
          ? user.modules
          : user.modules?.map(({ permissions, ...module }) => ({
              ...module,
              permissions: permissions.map((permision) => ({
                ...permision,
                assigned: checkModule(permision),
              })),
            }));
      };

      const getNotifications = () => {
        const updatedNotificationRef =
          user.recordsTmpUserNotificationEmail?.data?.userNotificationEmailTmps;

        const currentNotifications =
          user.notificationEmailList?.map(
            ({ nameTypeNotificationEmailTraslade, id }) => ({
              text: nameTypeNotificationEmailTraslade,
              id,
              key: 0,
            })
          ) || [];

        const updatedNotifications = updatedNotificationRef
          ? JSON.parse(updatedNotificationRef).map(
              ({ idNotification, nameNotification }) => ({
                text: nameNotification,
                id: idNotification,
                key: 1,
              })
            )
          : currentNotifications.map((notification) => ({
              ...notification,
              key: 1,
            }));

        return [...currentNotifications, ...updatedNotifications].reduce(
          (acc, { id, text, key }) => {
            if (!acc[id]) acc[id] = { text, [key]: true };
            else acc[id][key] = true;
            return acc;
          },
          {}
        );
      };

      const newUser = {
        current: {
          key: 0,
          title: "currentInformation",
          codUser: user.codUser,
          modules: user.modules,
          ...getFieldData(user, t),
        },
        ...(double && {
          updated: {
            key: 1,
            title: "updatedData",
            codUser: user.codUser,
            modules: getUpdatedModules(),
            ...getFieldData(dataRef || user, t),
          },
        }),
      };

      const itemsChanged = double
        ? Object.keys(newUser.current).reduce((acc, name) => {
            if (name === "modules") {
              newUser.current.modules.map(({ id, permissions }) => {
                const updatedModule = newUser.updated.modules.find(
                  (item) => item.id === id
                );

                return permissions.flatMap(({ assigned, id: permissionId }) => {
                  if (
                    assigned !==
                    updatedModule.permissions.find(
                      (permission) => permission.id === permissionId
                    ).assigned
                  )
                    acc.push(`modules-${id}-${permissionId}`);
                });
              });
            } else if (newUser.current[name] !== newUser.updated[name])
              acc.push(name);

            return acc;
          }, [])
        : [];

      return {
        user: newUser,
        double,
        notifications: getNotifications(),
        itemsChanged,
        userId: user.id,
      };
    }
  );

  useEffect(() => {
    const getInitialData = async () => {
      setLoading();
      await dispatch(
        getUserByCod(
          props.user.userCode,
          props.user.businessId,
          props.user.userType,
          props.user.country
        )
      );
      clearModal();
    };

    getInitialData();

    return () => dispatch(clearUserByCode());
  }, [props.user]);

  const { labels, buttonText } = {
    labels: t("general.labels", { returnObjects: true }),
    buttonText: t("general.buttons", { returnObjects: true }),
  };

  const getClassName = (updated, name, defaultClass) => {
    return updated && itemsChanged.includes(name)
      ? `${defaultClass} updated-info-color`
      : defaultClass;
  };

  const setLoading = () => setModal({ show: true, content: loadingHtml() });

  const clearModal = () => setModal(defaultModal);

  const handleSubmit = async (active) => {
    setLoading();
    const { title, description } = {
      title: t("admissions.tabs.users"),
      description: t("general.modal.success"),
    };
    try {
      await putApiCAll("/users/approve-or-rejected", {
        users: [{ idUser: userId, active }],
      });
      setModal({
        content: sucessInfoModal(title, description, {
          SelBtn: {
            text: buttonText.continue,
            action: () => {
              clearModal();
              goBack(true);
            },
          },
        }),
        show: true,
      });
    } catch (err) {
      let content;
      if (
        err.response !== undefined &&
        Array.isArray(err.response.data.notifications)
      ) {
        const notification = err?.response?.data?.notifications?.[0];
        content = errorContainer("Error", notification.description, {
          continueBtn: { text: buttonText.accept, action: clearModal },
        });
      }
      setModal({ content, show: true });
    }
  };

  return (
    <>
      {user?.current?.codUser && (
        <div className="row col-12 pendingDetails">
          {Object.keys(user).map((objKey) => {
            const current = user[objKey];
            const className = double ? "col-6" : "col-12";
            const updated = current.key === 1;
            return (
              <React.Fragment key={current.key}>
                <div className={className}>
                  <p
                    className={getClassName(
                      updated,
                      "title",
                      "edit-profile-style"
                    )}
                  >
                    <b>{labels[current.title]} :</b>
                    {current.codUser}
                  </p>
                  {fields.map((field, index) => (
                    <div className="row" key={index}>
                      {Object.keys(field).map((item, ind) => (
                        <div className="col-6" key={ind}>
                          <label
                            className={getClassName(
                              updated,
                              item,
                              "label-admin-client"
                            )}
                          >
                            {labels[field[item]]}
                          </label>
                          <input
                            className="input-admin-client input--text input-w-aux__input input--active"
                            id={item}
                            name={item}
                            type="text"
                            value={current[item]}
                            readOnly
                          />
                        </div>
                      ))}
                    </div>
                  ))}
                  <div className="clearfix modules">
                    {current.modules?.map((module, key) => (
                      <div key={`${module.id}-${key}`}>
                        <p>{module.displayName}</p>
                        <div className="roles">
                          {module.permissions.map((permission, moduleKey) => (
                            <CheckBox
                              key={`${module.code}-${permission.code}`}
                              id={`${module.code}-${permission.code}`}
                              name={`${key}-${moduleKey}`}
                              label={permission.displayName}
                              checked={permission.assigned}
                              disabled={true}
                              className={getClassName(
                                updated,
                                `modules-${module.id}-${permission.id}`
                              )}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  {Object.keys(notifications).length > 0 && (
                    <div className="clearfix modules" style={{ marginTop: 0 }}>
                      <div className="loaded-module-user">
                        <p>{t("general.buttons.notifications")}</p>
                        {Object.keys(notifications).map((id) => (
                          <div key={id}>
                            <CheckBox
                              name={`${current.key}-${id}`}
                              label={notifications[id].text}
                              checked={!!notifications[id][current.key]}
                              disabled={true}
                              className={getNotificationClass(
                                current.key,
                                notifications[id]
                              )}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                {current.key === 0 && (
                  <div className="form-actions clearfix">
                    <SecondaryButton
                      id={`back-btn`}
                      className="accept"
                      onClick={() => goBack(false)}
                    >
                      {buttonText.back}
                    </SecondaryButton>

                    <SecondaryButton
                      className="accept"
                      onClick={() => handleSubmit(false)}
                    >
                      {buttonText.rejected}
                    </SecondaryButton>
                    <PrimaryButton onClick={() => handleSubmit(true)}>
                      {buttonText.approve}
                    </PrimaryButton>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
      <Modal show={modal.show}>{modal.content}</Modal>
    </>
  );
};

export default ChangesUserDetail;

const fields = [
  {
    firstName: "name",
    lastName: "surname",
  },
  {
    identification: "id",
    email: "email",
  },
  {
    phone: "phone",
    codUser: "userCode",
  },
  { status: "state" },
];

const getFieldData = (
  { firstName, lastName, identification, email, phone, status },
  t
) => {
  return {
    firstName: firstName,
    lastName: lastName,
    identification: identification,
    email: email,
    phone: phone,
    status: status ? t(`general.states.${status}`) : null,
  };
};

const getNotificationClass = (key, notification) => {
  const defaultClass = "fix-checkbox-width";

  return key && notification[0] !== notification[1]
    ? `${defaultClass} updated-info-color `
    : defaultClass;
};
